import React from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { getShipnameList } from "../Actions/HelpersAPI";
import { getShippingCompanyList } from "../Actions/ShipViewAPI";
import ShippingCompanyCard from "./ShippingCompanyCard";
import Autocomplete from "react-autocomplete";
import $ from "jquery";
import Role from "../helpers/role";

let userRole = localStorage.getItem("UserRoles");

class ShippingCompanySearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchShip: {
        shipName: "",
        shipId: 0,
        companyName: "",
        PageNumber: 1,
        PageSize: 25,
        clientId: 0,
      },
    };
    this.SearchShips = this.SearchShips.bind(this);
    this.ClearShipSearchField = this.ClearShipSearchField.bind(this);
    this.handleShipInputChange = this.handleShipInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    if (match?.params?.id) {
      this.state.searchShip.clientId = match.params.id;
    }
    dispatch(getShipnameList());
    dispatch(getShippingCompanyList(this.state.searchShip));
    dispatch({ type: "SubBannerTitle", data: "Ship List" });
  }

  SearchShips(pageNo) {
    const { dispatch } = this.props;
    this.state.searchShip.PageNumber = pageNo;
    dispatch(getShippingCompanyList(this.state.searchShip));
  }

  ClearShipSearchField() {
    this.state.searchShip.shipName = "";
    this.state.searchShip.shipId = 0;
    this.props.dispatch(getShippingCompanyList(this.state.searchShip));
    this.setState({});
  }

  handleShipInputChange(e, node) {
    this.state.searchShip[node] = e.target.value;
    this.setState({});
  }

  handleAnnualSelectChange = (value, field, id, fieldId) => {
    const { dispatch } = this.props;
    this.state.searchShip[field] = value;
    this.state.searchShip[fieldId] = id;
    this.setState({});
  };

  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }
  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { ShipNameList, shippingCompanyList } = this.props;
    return (
      <div className="full-height">
        <div className="grey-bg  course-list-page">
          <div className="pt-3">
            {userRole == Role.client || userRole == Role.clientuser || userRole == Role.consultant ? (<></>) : (
              <div className="row px-3 pb-3">
                <button
                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                  onClick={() => this.BacktoPrevious()}
                >
                  <div style={{ position: 'relative' }}>
                    <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                  </div>
                </button>
              </div>
            )}
            <div
              className="card MM-card-header m-auto"
              style={{ backgroundColor: "white" }}
            >
              <div
                className="card-body flex"
                style={{
                  padding: "0rem",
                  backgroundColor: "#1a3464",
                  color: "white",
                }}
              >
                <h5
                  className="card-title ml-2 mt-2"
                  style={{ color: "092a51" }}
                >
                  Ship Search
                </h5>
              </div>
            </div>
            <div className="panel-box  search-filter-box mb-3">
              <div className="row" style={{ paddingBottom: "12px" }}>
                <div className="col-lg-4">
                  <label className="form-label">Ship Name</label>
                  <br></br>
                  <div className="autocomplete-wrappers">
                    <Autocomplete
                      value={this.state.searchShip.shipName}
                      contentEditable={true}
                      inputProps={{
                        placeholder: "Ship Name",
                      }}
                      items={ShipNameList ?? []}
                      name="shipName"
                      getItemValue={(item) => item.shipName}
                      shouldItemRender={this.renderShipNameTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item.shipName}
                        </div>
                      )}
                      onChange={(e) =>
                        this.handleShipInputChange(e, "shipName")
                      }
                      onSelect={(value, item) =>
                        this.handleAnnualSelectChange(
                          value,
                          "shipName",
                          item.shipID,
                          "shipId"
                        )
                      }
                    />
                  </div>
                </div>

                <div className="col-lg-8">
                  <label className="form-label"></label>
                  <br></br>
                  <div
                    className="mt-3 search-btn-col"
                    style={{ textAlign: "end" }}
                  >
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.SearchShips(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.ClearShipSearchField()}
                    >
                      {" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>

          {shippingCompanyList ? (
            <ShippingCompanyCard
              arraylist={shippingCompanyList.data}
              pageSize={shippingCompanyList.pagination.pageSize}
              totalRecords={
                shippingCompanyList.pagination.totalcount
                  ? shippingCompanyList.pagination.totalcount
                  : 0
              }
              setUpdatedState={(value) => this.SearchShips(value)}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ShipNameList: state.UserManageReducer.ShipNameList || [],
    shippingCompanyList: state.ShipViewReducer.ShippingCompanyList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShippingCompanySearch);
